import * as types from './action-types';

export const serverError = ({status, msg}) => ({ type: types.SERVER_ERROR, status, msg });
export const clearServerError= () => ({ type: types.CLEAR_SERVER_ERROR });



// WEBPACK FOOTER //
// ./src/server/actions.js